import { useEffect, useState } from "react";
import Seo from "@/components/Seo";
import PageHeader from "@/components/PageHeader";
import ReviewsSection from "@/components/ReviewsSection";
import CtaBand from "@/components/CtaBand";
import { api } from "@/lib/api";

export default function Reviews() {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    api
      .get("/reviews")
      .then((r) => setReviews(r.data))
      .catch(() => setReviews([]))
      .finally(() => setLoading(false));
  };
  useEffect(load, []);

  return (
    <>
      <Seo
        title="Reviews & Customer Feedback"
        description="Read verified customer feedback for Kensmarc Electric, or share your own experience working with our licensed Los Angeles County electrical contractor."
        path="/reviews"
      />
      <PageHeader
        eyebrow="Reviews"
        title="Customer feedback"
        subtitle="Honest feedback from real Kensmarc Electric customers. Worked with us? Share your experience — verified reviews appear here."
      />

      <section className="section-pad">
        <div className="container-kx">
          <ReviewsSection reviews={reviews} loading={loading} onSubmitted={load} />
        </div>
      </section>

      <CtaBand />
    </>
  );
}
